<div class="loading" *ngIf="isLoading">Loading&#8230;</div>

<h4>
    <fa name="user"></fa> {{userReviewedName}} - Reviewed Records
</h4>

<ag-grid-angular (gridReady)="onGridReady($event)" (firstDataRendered)="autoSizeAll()" style="width: 100%; height: calc(100% - 52px)" [enableColResize]="true" [paginationAutoPageSize]="true" [pagination]="false" class="ag-theme-alpine" [rowData]="rows"
    [columnDefs]="columnDefs" [enableSorting]="true" [enableFilter]="true" [overlayNoRowsTemplate]='noDataText'>
</ag-grid-angular>